import React, {createContext, useContext, useEffect, useState} from 'react';
import api, {consoleDevLog} from "../apiConfig";

export const MarketingContext = createContext();

export const useMarketingMaterials = () => {
    return useContext(MarketingContext);
};

export const MarketingProvider = ({ children }) => {
    const [marketingMaterials, setMarketingMaterials] = useState([
        // Initially populated with your sample reports or fetched from a server.
    ]);

    useEffect(() => {
        api.get('/marketing/email')
            .then(response => {
                // Print the keys in each value of response.data
                response.data.forEach((contact) => {
                    consoleDevLog(Object.keys(contact));
                })
                setMarketingMaterials(response.data);
            })
            .catch(error => {
                console.error('There was an error fetching the data: ', error);
            });
    }, []); // The empty dependency array ensures the API call is made only once, when the component mounts


    const addMarketingMaterials = (marketingMaterial) => {
        consoleDevLog('Adding marketing material to context with data:', marketingMaterial);
        setMarketingMaterials(prevMarketingMaterials => [...prevMarketingMaterials, marketingMaterial]);
    };

    const removeMarketingMaterial = (indexToRemove) => {
        const updatedMarketingMaterials = marketingMaterials.filter((_, index) => index !== indexToRemove);
        setMarketingMaterials(updatedMarketingMaterials);
    };

    return (
        <MarketingContext.Provider value={{ marketingMaterials, addMarketingMaterials, removeMarketingMaterial }}>
            {children}
        </MarketingContext.Provider>
    );
};
